import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import {
  FiBriefcase,
  FiHome,
  FiActivity,
  FiBookOpen,
  FiShoppingBag,
  FiCalendar,
} from 'react-icons/fi';
import './UseCases.css';

const useCases = [
  {
    Icon: FiBriefcase,
    title: 'Ресепшн и приёмная',
    description: 'Встречает посетителей, отвечает на вопросы, вызывает нужного сотрудника, выдаёт пропуска.',
    industries: ['Бизнес-центры', 'Офисы', 'Госучреждения'],
  },
  {
    Icon: FiHome,
    title: 'Гостиничный сервис',
    description: 'Регистрация гостей, информация об услугах, заказ еды в номер, вызов такси, бронирование экскурсий.',
    industries: ['Отели', 'Санатории', 'Хостелы'],
  },
  {
    Icon: FiActivity,
    title: 'Медицинские учреждения',
    description: 'Запись на приём, навигация по клинике, информация о врачах и услугах, напоминания о визитах.',
    industries: ['Клиники', 'Поликлиники', 'Диагностические центры'],
  },
  {
    Icon: FiBookOpen,
    title: 'Образование',
    description: 'Информация для абитуриентов, навигация по кампусу, расписание, помощь с документами.',
    industries: ['Университеты', 'Школы', 'Учебные центры'],
  },
  {
    Icon: FiShoppingBag,
    title: 'Торговые центры',
    description: 'Навигация по ТЦ, информация о магазинах и акциях, программа лояльности, сбор обратной связи.',
    industries: ['ТЦ', 'Магазины', 'Шоурумы'],
  },
  {
    Icon: FiCalendar,
    title: 'Мероприятия и выставки',
    description: 'Регистрация участников, программа события, информация о спикерах, сбор контактов.',
    industries: ['Конференции', 'Выставки', 'Форумы'],
  },
];

const UseCases = () => {
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <section className="usecases" ref={ref}>
      <motion.div
        className="usecases-container"
        initial={{ opacity: 0 }}
        animate={inView ? { opacity: 1 } : {}}
        transition={{ duration: 0.8 }}
      >
        <motion.div
          className="usecases-header"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className="section-title">Сценарии применения</h2>
          <p className="section-subtitle">Аватар адаптируется под любую задачу и отрасль</p>
        </motion.div>

        <div className="usecases-grid">
          {useCases.map((useCase, index) => (
            <motion.div
              key={useCase.title}
              className="usecase-card"
              initial={{ opacity: 0, y: 40 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.2 + index * 0.1 }}
              whileHover={{ y: -8, scale: 1.02 }}
            >
              <div className="usecase-icon-wrapper">
                <useCase.Icon className="usecase-icon" aria-hidden="true" />
              </div>
              <h3 className="usecase-title">{useCase.title}</h3>
              <p className="usecase-description">{useCase.description}</p>
              <div className="usecase-industries">
                {useCase.industries.map((industry) => (
                  <span key={industry} className="industry-tag">{industry}</span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default UseCases;
